import axios from 'axios'
import md5 from 'vux/src/tools/md5/index.js'
import numberRandom from 'vux/src/tools/number/random.js'
import AlertModule from 'vux/src/plugins/alert/module'

import CryptoJS from 'crypto-js'
import { getUser,clearUser,getCollege } from './cache'
import {childWebsite} from './config'


axios.interceptors.response.use(function (res) {

if(res.data.code && res.data.code.trim() == '401') {
AlertModule.show({
title: '',
content: '本账号已在其他设备登录，请重新登录',
maskZIndex:3000,
onHide () {
clearUser()
window.location.href=`${childWebsite}/login`

}
})

}
if(res.config&&res.status){
return res.data
}
return res;
}, function (error) {
return Promise.reject(error);
});



axios.interceptors.request.use(function (config) {

var getTime =  new Date().getTime();
var randomValue = numberRandom(100000, 999999);

var base = encryptDes(getTime.toString(), '!x@h#y$1')

var mima = ''
var getuserid = 0
let token = ""
let collegeId = getCollege()? getCollege().college_id:{}
var getuservalue = getUser()
if(getuservalue && getuservalue.customerkey){
mima = md5(base+randomValue+getuservalue.customerkey);
getuserid = getuservalue.id
token = getuservalue.token ? getuservalue.token.token : ""
}else{
mima = md5(base+randomValue);
}

config.headers['time'] = getTime
config.headers['random'] = randomValue
config.headers['digest'] = mima
config.headers['userId'] = getuserid
config.headers['collegeId'] = collegeId
config.headers['channel'] = 'h5'
config.headers['token'] = token
return config;
}, function (error) {
console.log(error,'error')

return Promise.reject(error);
});


export const encryptDes=(message, key)=>{
var afterEncrypt = CryptoJS.DES.encrypt(message, CryptoJS.enc.Utf8.parse(key), {
mode: CryptoJS.mode.ECB,
padding: CryptoJS.pad.Pkcs7
}).toString();

return afterEncrypt
}


export default axios


// WEBPACK FOOTER //
// ./src/common/js/axios.js